export const listType = {
  COURSE: 'course',
  ACTIVITY: 'activity',
  ACTIVITY_COURSE: 'activityCourse',
  SCHOOL: 'school',
  COACH: 'coach',
  UPLOAD_COACH: 'uploadCoach',
  ORDER: 'order',
  STOCK: 'stock',
  STUDENT: 'student',
  CERT: 'cert',
};
